import { Component, h, render, FunctionComponent, Fragment } from 'preact'
import {
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  VKIcon,
  VKShareButton
} from 'react-share'
import useragent from './useragent'

class SocialButtons extends Component<{
  name: string,
  text: string,
  image: string
}> {
  get url() {
    const loc = window.location
    return `${loc.protocol}//${loc.host}${loc.pathname}?dead=${this.props.name}`
  }

  share = () => {
    // noinspection JSIgnoredPromiseFromCall
    window.navigator.share({
      title: this.title,
      text: this.props.text,
      url: this.url
    })
  }

  networks: Array<{
    name: string,
    component: FunctionComponent<any>,
    title?: string,
    icon?: FunctionComponent<any>
    useDescription?: boolean,
    inlineImage?: boolean
  }> = [
    {
      component: TelegramShareButton,
      name: 'telegram',
      icon: TelegramIcon
    },
    {
      component: FacebookShareButton,
      name: 'facebook',
      icon: FacebookIcon,
      useDescription: true
    },
    {
      component: TwitterShareButton,
      name: 'twitter',
      icon: TwitterIcon
    },
    {
      component: VKShareButton,
      name: 'vk',
      icon: VKIcon,
      useDescription: true
    },
  ];

  get title() {
    return document.querySelector('title').innerText
  }

  get description() {
    return document.querySelector('meta[name="description"]').getAttribute('content')
  }

  get image() {
    const meta = document.querySelector('meta[property="vk:image"]')
    return meta ? meta.getAttribute('content') : ''
  }

  render() {
    if (window.navigator.share && !useragent.isDesktopOS) {
      return <button
        className='modal-button modal-button-small'
        onClick={this.share}
      >
        Поделиться
      </button>
    }

    const buttons = []

    this.networks.forEach(social => {
      const Component = social.component
      let description = ''
      let title = this.props.text
      if (social.useDescription) {
        title = this.title
        description = this.props.text
      }
      let url = this.url
      if (social.inlineImage) {
        url = `${this.props.image} ${url}`
      }

      buttons.push(<Component
        className='modal-button modal-button-icon'
        resetButtonStyle={false}
        url={url}
        title={title}
        description={description}
        quote={description}
        image={this.props.image}
        related={['@stopgameru']}
      >
        <social.icon />
      </Component>)
    })

    return <>
      {buttons}
    </>
  }
}

export default (elements, name, text, image) => {
  elements.forEach(container => {
    render(<div className='social-links'>
        <SocialButtons name={name} text={text} image={image} />
    </div>, container)
  })
}
